import React from 'react';

import { PayoutRequisitesDetailsPage } from 'features/payout-requisites';

export const TraderPayoutRequisitesDetailsPage: React.FC = () => (
  <PayoutRequisitesDetailsPage />
);
